import { jsPDF } from "jspdf";

import type { Chart } from "@web-app/types";

const GRID_ROW_HEIGHT = 120; // Must match DashboardGrid rowHeight

// PDF dimensions in mm (A4 landscape)
const PDF_WIDTH = 297;
const PDF_HEIGHT = 210;
const MARGIN = 15;
const HEADER_HEIGHT = 25; // Space for logo and title
const CONTENT_WIDTH = PDF_WIDTH - 2 * MARGIN;
const CONTENT_HEIGHT = PDF_HEIGHT - 2 * MARGIN - HEADER_HEIGHT;

// FULFLLD logo as inline SVG (black text on transparent background)
const LOGO_SVG = `<svg width="76" height="16" viewBox="0 0 76 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_648_4007)">
<path d="M36.7049 0.0429688H46.1768C46.3148 0.0429688 46.4266 0.154521 46.4266 0.292129V4.14434C46.4266 4.28195 46.3148 4.3935 46.1768 4.3935H41.4127C41.2747 4.3935 41.1629 4.50506 41.1629 4.64266V6.56836C41.1629 6.70597 41.2747 6.81752 41.4127 6.81752H45.1147C45.2527 6.81752 45.3645 6.92908 45.3645 7.06668V10.5085C45.3645 10.6461 45.2527 10.7577 45.1147 10.7577H41.4127C41.2747 10.7577 41.1629 10.8692 41.1629 11.0068V15.7515C41.1629 15.8891 41.051 16.0006 40.9131 16.0006H36.7049C36.5669 16.0006 36.4551 15.8891 36.4551 15.7515V0.292129C36.4551 0.154521 36.5669 0.0429688 36.7049 0.0429688Z" fill="#232323"/>
<path d="M23.7822 0.0429688C23.9202 0.0429688 24.032 0.154521 24.032 0.292129V9.73905C24.032 13.8437 21.8238 15.9998 17.6156 15.9998C13.4074 15.9998 11.2457 13.8437 11.1992 9.73905V0.292129C11.1992 0.154521 11.3111 0.0429688 11.449 0.0429688H15.734C15.8719 0.0429688 15.9838 0.154521 15.9838 0.292129L15.9887 10.1568C15.9887 11.2234 16.5927 11.8496 17.6164 11.8496C18.6401 11.8496 19.2434 11.2234 19.2434 10.1804V0.292129C19.2434 0.154521 19.3552 0.0429688 19.4932 0.0429688H23.7822Z" fill="#232323"/>
<path d="M67.4575 0C72.3857 0 75.6641 3.17639 75.6641 8C75.6641 12.8236 72.3865 16 67.4575 16H61.9881C61.8501 16 61.7383 15.8884 61.7383 15.7508V15.6523V0.347684V0.24916C61.7383 0.111552 61.8501 0 61.9881 0H62.064H67.4575ZM67.7367 11.8262C69.5269 11.8262 70.7359 10.2954 70.7359 8C70.7359 5.70463 69.5269 4.17384 67.7367 4.17384H66.7775C66.6396 4.17384 66.5277 4.28539 66.5277 4.423V11.577C66.5277 11.7146 66.6396 11.8262 66.7775 11.8262H67.7367Z" fill="#232323"/>
<path d="M0.249798 0.0429688H9.72172C9.85968 0.0429688 9.97152 0.154521 9.97152 0.292129V4.14434C9.97152 4.28195 9.85968 4.3935 9.72172 4.3935H4.9576C4.81964 4.3935 4.7078 4.50506 4.7078 4.64266V6.56836C4.7078 6.70597 4.81964 6.81752 4.9576 6.81752H8.65967C8.79763 6.81752 8.90947 6.92908 8.90947 7.06668V10.5085C8.90947 10.6461 8.79763 10.7577 8.65967 10.7577H4.9576C4.81964 10.7577 4.7078 10.8692 4.7078 11.0068V15.7515C4.7078 15.8891 4.59596 16.0006 4.458 16.0006H0.249798C0.111838 16.0006 0 15.8891 0 15.7515V0.292129C0 0.154521 0.111838 0.0429688 0.249798 0.0429688Z" fill="#232323"/>
<path d="M52.1087 0.0429688H47.9021C47.7642 0.0429688 47.6523 0.154521 47.6523 0.292129V15.7507C47.6523 15.8883 47.7642 15.9998 47.9021 15.9998H60.2296C60.3676 15.9998 60.4794 15.8883 60.4794 15.7507V12.3039C60.4794 12.1663 60.3676 12.0548 60.2296 12.0548H52.6091C52.4712 12.0548 52.3593 11.9432 52.3593 11.8056V0.292129C52.3593 0.154521 52.2475 0.0429688 52.1095 0.0429688H52.1087Z" fill="#232323"/>
<path d="M29.7122 0.0429688H25.5057C25.3677 0.0429688 25.2559 0.154521 25.2559 0.292129V15.7507C25.2559 15.8883 25.3677 15.9998 25.5057 15.9998H34.9792C35.1172 15.9998 35.229 15.8883 35.229 15.7507V12.3039C35.229 12.1663 35.1172 12.0548 34.9792 12.0548H30.2126C30.0747 12.0548 29.9628 11.9432 29.9628 11.8056V0.292129C29.9628 0.154521 29.851 0.0429688 29.713 0.0429688H29.7122Z" fill="#232323"/>
<path d="M60.2279 6.81752H58.5455C58.4075 6.81752 58.2957 6.70597 58.2957 6.56836V0.292129C58.2957 0.154521 58.1838 0.0429688 58.0459 0.0429688H53.8377C53.6997 0.0429688 53.5879 0.154521 53.5879 0.292129V10.5085C53.5879 10.6461 53.6997 10.7577 53.8377 10.7577H60.2279C60.3659 10.7577 60.4777 10.6461 60.4777 10.5085V7.06668C60.4777 6.92908 60.3659 6.81752 60.2279 6.81752Z" fill="#232323"/>
</g>
<defs>
<clipPath id="clip0_648_4007">
<rect width="75.6636" height="16" fill="white"/>
</clipPath>
</defs>
</svg>`;

interface ExportOptions {
  charts: Chart[];
  dashboardTitle: string;
  dateRange: { from: string; to: string };
  gridElement: HTMLElement;
}

/**
 * Calculate safe page break points based on chart positions.
 * Returns an array of pixel heights where pages should break.
 */
function calculatePageBreaks(charts: Chart[], pixelsPerPage: number): number[] {
  if (charts.length === 0) return [];

  // Find the maximum row end (y + h) across all charts
  const maxRowEnd = Math.max(
    ...charts.map((c) => c.gridPosition.y + c.gridPosition.h),
  );
  const totalHeight = maxRowEnd * GRID_ROW_HEIGHT;

  if (totalHeight <= pixelsPerPage) {
    // Content fits in one page
    return [totalHeight];
  }

  const breaks: number[] = [];
  let currentPageEnd = pixelsPerPage;

  while (currentPageEnd < totalHeight) {
    // Find charts that span across this potential break point
    const chartsCrossingBreak = charts.filter((chart) => {
      const chartTop = chart.gridPosition.y * GRID_ROW_HEIGHT;
      const chartBottom =
        (chart.gridPosition.y + chart.gridPosition.h) * GRID_ROW_HEIGHT;
      return chartTop < currentPageEnd && chartBottom > currentPageEnd;
    });

    if (chartsCrossingBreak.length > 0) {
      // Find the topmost chart that crosses the break
      const topMostCrossingChart = chartsCrossingBreak.reduce((min, chart) =>
        chart.gridPosition.y < min.gridPosition.y ? chart : min,
      );
      // Move break point to just before this chart starts
      const safeBreak = topMostCrossingChart.gridPosition.y * GRID_ROW_HEIGHT;

      if (safeBreak > (breaks.length > 0 ? breaks[breaks.length - 1] : 0)) {
        breaks.push(safeBreak);
        currentPageEnd = safeBreak + pixelsPerPage;
      } else {
        // Chart is too tall - we have to break it (edge case)
        breaks.push(currentPageEnd);
        currentPageEnd += pixelsPerPage;
      }
    } else {
      // No charts cross this break - it's safe
      breaks.push(currentPageEnd);
      currentPageEnd += pixelsPerPage;
    }
  }

  // Add final break at total height
  if (breaks[breaks.length - 1] < totalHeight) {
    breaks.push(totalHeight);
  }

  return breaks;
}

/**
 * Convert inline SVG to PNG data URL at higher resolution for crisp PDF output
 */
async function svgToPngDataUrl(
  svgString: string,
  scale: number = 4,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const svgBlob = new Blob([svgString], { type: "image/svg+xml" });
    const url = URL.createObjectURL(svgBlob);

    img.onload = () => {
      const canvas = document.createElement("canvas");
      // Scale up for higher resolution in PDF
      canvas.width = img.width * scale;
      canvas.height = img.height * scale;
      const ctx = canvas.getContext("2d");
      if (ctx) {
        ctx.scale(scale, scale);
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(url);
        resolve(canvas.toDataURL("image/png"));
      } else {
        URL.revokeObjectURL(url);
        reject(new Error("Could not get canvas context"));
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Failed to load SVG"));
    };
    img.src = url;
  });
}

/**
 * Add header (logo + title + date range) to a PDF page
 */
async function addHeader(
  pdf: jsPDF,
  title: string,
  dateRange: { from: string; to: string },
  logoDataUrl: string,
  pageNumber: number,
  totalPages: number,
): Promise<void> {
  // Add logo (left side) - SVG is 76x16, maintain aspect ratio
  const logoHeight = 6;
  const logoWidth = logoHeight * (76 / 16); // ~28.5mm to maintain aspect ratio
  pdf.addImage(logoDataUrl, "PNG", MARGIN, MARGIN, logoWidth, logoHeight);

  // Add title (center)
  pdf.setFontSize(14);
  pdf.setFont("helvetica", "bold");
  pdf.text(title, PDF_WIDTH / 2, MARGIN + 5, { align: "center" });

  // Add date range (below title)
  pdf.setFontSize(9);
  pdf.setFont("helvetica", "normal");
  pdf.setTextColor(100, 100, 100);
  const dateText = `${dateRange.from} to ${dateRange.to}`;
  pdf.text(dateText, PDF_WIDTH / 2, MARGIN + 11, { align: "center" });

  // Add page number (right side)
  pdf.setFontSize(8);
  pdf.text(
    `Page ${pageNumber} of ${totalPages}`,
    PDF_WIDTH - MARGIN,
    MARGIN + 5,
    {
      align: "right",
    },
  );

  // Reset text color
  pdf.setTextColor(0, 0, 0);
}

/**
 * Export dashboard to PDF with smart pagination
 */
export async function exportDashboardToPdf({
  charts,
  dashboardTitle,
  dateRange,
  gridElement,
}: ExportOptions): Promise<void> {
  // Calculate the full height of the grid content based on chart positions
  const maxRowEnd =
    charts.length > 0
      ? Math.max(...charts.map((c) => c.gridPosition.y + c.gridPosition.h))
      : 1;
  const fullGridHeight = maxRowEnd * GRID_ROW_HEIGHT;

  // Calculate scale factor: how many pixels fit in the PDF content area
  const gridWidth = gridElement.scrollWidth;
  const pdfScale = CONTENT_WIDTH / (gridWidth / 3.78); // Convert px to mm (assuming 96 DPI)
  const pixelsPerPage = (CONTENT_HEIGHT / pdfScale) * 3.78;

  // Calculate page breaks
  const pageBreaks = calculatePageBreaks(charts, pixelsPerPage);
  const totalPages = Math.max(1, pageBreaks.length);

  // Load logo from inline SVG
  let logoDataUrl: string;
  try {
    logoDataUrl = await svgToPngDataUrl(LOGO_SVG);
  } catch {
    // Use a simple text fallback if logo fails to load
    logoDataUrl = "";
  }

  // Create PDF
  const pdf = new jsPDF({
    format: "a4",
    orientation: "landscape",
    unit: "mm",
  });

  // Instead of using html2canvas (which has issues with Tailwind's color() function),
  // we'll manually composite the chart canvases onto a single canvas.
  // This approach directly captures the AG Charts canvas elements.

  const gridRect = gridElement.getBoundingClientRect();
  const canvasScale = 2; // For higher resolution

  // Create a canvas to hold the entire grid
  const canvas = document.createElement("canvas");
  canvas.width = gridRect.width * canvasScale;
  canvas.height = fullGridHeight * canvasScale;
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Could not get canvas context");
  }

  // Fill with white background
  ctx.fillStyle = "#ffffff";
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.scale(canvasScale, canvasScale);

  // Find all chart containers in the grid and draw them
  const chartContainers = gridElement.querySelectorAll("[data-grid]");

  // Also look for react-grid-layout items
  const gridItems = gridElement.querySelectorAll(".react-grid-item");

  const itemsToDraw =
    gridItems.length > 0 ? gridItems : Array.from(chartContainers);

  // If no specific items found, look for direct children with transforms
  const allItems =
    itemsToDraw.length > 0
      ? itemsToDraw
      : gridElement.querySelectorAll('[style*="transform"]');

  for (const item of allItems) {
    if (!(item instanceof HTMLElement)) continue;

    // Get the item's position relative to the grid
    const itemRect = item.getBoundingClientRect();
    const x = itemRect.left - gridRect.left;
    const y = itemRect.top - gridRect.top;

    // Draw white background for the chart container
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(x, y, itemRect.width, itemRect.height);

    // Draw a border around the chart container
    ctx.strokeStyle = "#e5e7eb";
    ctx.lineWidth = 0.5;
    ctx.strokeRect(x, y, itemRect.width, itemRect.height);

    // Draw the chart title if present
    const titleEl = item.querySelector("h3");
    let titleHeight = 0;
    if (titleEl) {
      const titleRect = titleEl.getBoundingClientRect();
      titleHeight = titleRect.height + 16; // padding

      // Draw title background
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(x, y, itemRect.width, titleHeight);

      // Draw title text
      ctx.fillStyle = "#111827";
      ctx.font = "600 13px system-ui, -apple-system, sans-serif";
      ctx.fillText(titleEl.textContent || "", x + 12, y + 18);

      // Draw border under title
      ctx.strokeStyle = "#f3f4f6";
      ctx.beginPath();
      ctx.moveTo(x, y + titleHeight - 4);
      ctx.lineTo(x + itemRect.width, y + titleHeight - 4);
      ctx.stroke();
    }

    // Find canvas elements within this chart (AG Charts renders to canvas)
    const chartCanvases = item.querySelectorAll("canvas");
    let hasCanvas = false;

    for (const chartCanvas of chartCanvases) {
      if (!(chartCanvas instanceof HTMLCanvasElement)) continue;
      hasCanvas = true;

      const canvasRect = chartCanvas.getBoundingClientRect();
      const canvasX = canvasRect.left - gridRect.left;
      const canvasY = canvasRect.top - gridRect.top;

      // Draw the chart canvas onto our composite canvas
      try {
        ctx.drawImage(
          chartCanvas,
          canvasX,
          canvasY,
          canvasRect.width,
          canvasRect.height,
        );
      } catch {
        // Canvas might be tainted, skip it
        console.warn("Could not draw canvas - may be tainted");
      }
    }

    // If no canvas found, this might be a metric or table chart - draw text content
    if (!hasCanvas) {
      // Check for metric values (large bold text)
      const metricValues = item.querySelectorAll(".text-2xl.font-bold");
      if (metricValues.length > 0) {
        // This is a metric chart
        const metricsContainer = item.querySelector(".flex.items-center");
        if (metricsContainer) {
          // Multiple metrics in a row
          const metrics = metricsContainer.querySelectorAll(".flex-1");
          metrics.forEach((metric) => {
            const valueEl = metric.querySelector(".text-2xl");
            const labelEl = metric.querySelector(".text-sm");

            if (valueEl instanceof HTMLElement) {
              const valueRect = valueEl.getBoundingClientRect();
              const valueX = valueRect.left - gridRect.left;
              const valueY = valueRect.top - gridRect.top;

              ctx.fillStyle = "#111827";
              ctx.font = "700 24px system-ui, -apple-system, sans-serif";
              ctx.textAlign = "center";
              ctx.fillText(
                valueEl.textContent || "",
                valueX + valueRect.width / 2,
                valueY + 24,
              );
            }

            if (labelEl instanceof HTMLElement) {
              const labelRect = labelEl.getBoundingClientRect();
              const labelX = labelRect.left - gridRect.left;
              const labelY = labelRect.top - gridRect.top;

              ctx.fillStyle = "#4b5563";
              ctx.font = "400 12px system-ui, -apple-system, sans-serif";
              ctx.textAlign = "center";
              ctx.fillText(
                labelEl.textContent || "",
                labelX + labelRect.width / 2,
                labelY + 14,
              );
            }
          });
          ctx.textAlign = "left"; // Reset
        } else {
          // Single metric
          metricValues.forEach((valueEl) => {
            if (valueEl instanceof HTMLElement) {
              const valueRect = valueEl.getBoundingClientRect();
              const valueX = valueRect.left - gridRect.left;
              const valueY = valueRect.top - gridRect.top;

              ctx.fillStyle = "#111827";
              ctx.font = "700 24px system-ui, -apple-system, sans-serif";
              ctx.textAlign = "center";
              ctx.fillText(
                valueEl.textContent || "",
                valueX + valueRect.width / 2,
                valueY + 24,
              );
              ctx.textAlign = "left";
            }
          });
        }
      }

      // Check for table
      const table = item.querySelector("table");
      if (table instanceof HTMLTableElement) {
        // Clip table content to the chart container bounds
        const clipTop = y + titleHeight;
        const clipBottom = y + itemRect.height;
        const clipLeft = x;
        const clipRight = x + itemRect.width;

        ctx.save();
        ctx.beginPath();
        ctx.rect(clipLeft, clipTop, clipRight - clipLeft, clipBottom - clipTop);
        ctx.clip();

        // Draw table headers
        const headers = table.querySelectorAll("th");
        headers.forEach((th) => {
          if (th instanceof HTMLElement) {
            const thRect = th.getBoundingClientRect();
            const thX = thRect.left - gridRect.left;
            const thY = thRect.top - gridRect.top;

            // Skip if outside visible area
            if (thY + thRect.height < clipTop || thY > clipBottom) return;

            // Header background
            ctx.fillStyle = "#f9fafb";
            ctx.fillRect(thX, thY, thRect.width, thRect.height);

            // Header border
            ctx.strokeStyle = "#e5e7eb";
            ctx.lineWidth = 0.5;
            ctx.strokeRect(thX, thY, thRect.width, thRect.height);

            // Header text
            ctx.fillStyle = "#374151";
            ctx.font = "500 11px system-ui, -apple-system, sans-serif";
            ctx.fillText(th.textContent || "", thX + 8, thY + 16);
          }
        });

        // Draw table cells
        const cells = table.querySelectorAll("td");
        cells.forEach((td) => {
          if (td instanceof HTMLElement) {
            const tdRect = td.getBoundingClientRect();
            const tdX = tdRect.left - gridRect.left;
            const tdY = tdRect.top - gridRect.top;

            // Skip if outside visible area
            if (tdY + tdRect.height < clipTop || tdY > clipBottom) return;

            // Cell background
            ctx.fillStyle = "#ffffff";
            ctx.fillRect(tdX, tdY, tdRect.width, tdRect.height);

            // Cell border
            ctx.strokeStyle = "#f3f4f6";
            ctx.lineWidth = 0.5;
            ctx.strokeRect(tdX, tdY, tdRect.width, tdRect.height);

            // Cell text
            ctx.fillStyle = "#111827";
            ctx.font = "400 11px system-ui, -apple-system, sans-serif";
            ctx.fillText(td.textContent || "", tdX + 8, tdY + 16);
          }
        });

        ctx.restore();
      }
    }
  }

  // Process each page
  let previousBreak = 0;
  for (let pageIndex = 0; pageIndex < totalPages; pageIndex++) {
    if (pageIndex > 0) {
      pdf.addPage();
    }

    // Add header
    if (logoDataUrl) {
      await addHeader(
        pdf,
        dashboardTitle,
        dateRange,
        logoDataUrl,
        pageIndex + 1,
        totalPages,
      );
    } else {
      // Text-only header if logo failed
      pdf.setFontSize(14);
      pdf.setFont("helvetica", "bold");
      pdf.text("FULFLLD", MARGIN, MARGIN + 5);
      pdf.text(dashboardTitle, PDF_WIDTH / 2, MARGIN + 5, { align: "center" });
      pdf.setFontSize(9);
      pdf.setFont("helvetica", "normal");
      pdf.setTextColor(100, 100, 100);
      pdf.text(
        `${dateRange.from} to ${dateRange.to}`,
        PDF_WIDTH / 2,
        MARGIN + 11,
        {
          align: "center",
        },
      );
      pdf.setFontSize(8);
      pdf.text(
        `Page ${pageIndex + 1} of ${totalPages}`,
        PDF_WIDTH - MARGIN,
        MARGIN + 5,
        {
          align: "right",
        },
      );
      pdf.setTextColor(0, 0, 0);
    }

    // Calculate which portion of the canvas to use for this page
    const currentBreak = pageBreaks[pageIndex] || canvas.height / 2;
    const sourceY = previousBreak * canvasScale;
    const sourceHeight = (currentBreak - previousBreak) * canvasScale;

    // Create a temporary canvas for this page's content
    const pageCanvas = document.createElement("canvas");
    pageCanvas.width = canvas.width;
    pageCanvas.height = sourceHeight;
    const pageCtx = pageCanvas.getContext("2d");

    if (pageCtx) {
      pageCtx.fillStyle = "#ffffff";
      pageCtx.fillRect(0, 0, pageCanvas.width, pageCanvas.height);
      pageCtx.drawImage(
        canvas,
        0,
        sourceY,
        canvas.width,
        sourceHeight,
        0,
        0,
        canvas.width,
        sourceHeight,
      );

      // Calculate dimensions for PDF
      const imgWidth = CONTENT_WIDTH;
      const imgHeight = (sourceHeight / canvas.width) * imgWidth;

      // Add to PDF
      const imgData = pageCanvas.toDataURL("image/png");
      pdf.addImage(
        imgData,
        "PNG",
        MARGIN,
        MARGIN + HEADER_HEIGHT,
        imgWidth,
        Math.min(imgHeight, CONTENT_HEIGHT),
      );
    }

    previousBreak = currentBreak;
  }

  // Generate filename with date
  const date = new Date().toISOString().split("T")[0];
  const sanitizedTitle = dashboardTitle.replace(/[^a-zA-Z0-9]/g, "_");
  const filename = `${sanitizedTitle}_${date}.pdf`;

  // Open in new tab and trigger download
  const pdfBlob = pdf.output("blob");
  const blobUrl = URL.createObjectURL(pdfBlob);

  // Create a link to trigger download with proper filename
  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;
  link.click();

  // Clean up the blob URL after a short delay
  setTimeout(() => {
    URL.revokeObjectURL(blobUrl);
  }, 1000);
}
